import firebase from 'firebase'
import firebaseConfig from '../../firebase/firebaseConfig'
import 'firebase/firestore'

let googleProvider = new firebase.auth.GoogleAuthProvider();
let facebookProvider = new firebase.auth.FacebookAuthProvider();
let twitterProvider = new firebase.auth.TwitterAuthProvider();
let firestore

export default {

	// Init

	start() {
		firebase.initializeApp(firebaseConfig)
		firestore = firebase.firestore();
		const settings = {/* your settings... */ timestampsInSnapshots: true};
		firestore.settings(settings);
		return this
	},

	// Session 

	onSessionChanged(callback) {
		return firebase.auth().onAuthStateChanged(callback)
	},

	signInWith(accountType) {
		switch (accountType) {
			case 'google':
				return this.loginUserWithProvider(googleProvider)
			case 'facebook':
				return this.loginUserWithProvider(facebookProvider)
			case 'twitter':
				return this.loginUserWithProvider(twitterProvider)
			default:
		}
	},

	loginUserWithEmail(email, password) {
		return firebase.auth().signInWithEmailAndPassword(email, password)
	},

	loginUserWithProvider(provider) {
		return firebase.auth().signInWithPopup(provider)
	},

	registerNewUser(email, password) {
		return firebase.auth().createUserWithEmailAndPassword(email,password)
	},

	signOut() {
		return firebase.auth().signOut()
	},

	// User
	user() {
		return firebase.auth().currentUser
	},

	userProfilePicture() {
		return this.user().photoURL
	},

	userId() {
		return this.user().uid
	},

	// Database manipulation

	db() {
		return firestore
	},

	storage() {
		return firebase.storage()
	},
}


// WEBPACK FOOTER //
// ./src/controllers/FirebaseController.js